package ru.it_mozaika.sender.js.application.components.segments

import io.ktor.client.call.*
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toJSDate
import mui.material.*
import mui.system.responsive
import mui.system.sx
import muix.pickers.AdapterMoment
import muix.pickers.DateTimePicker
import muix.pickers.LocalizationProvider
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.FC
import react.Props
import react.ReactNode
import react.VFC
import react.create
import react.dom.events.MouseEventHandler
import react.dom.onChange
import react.useEffect
import react.useMemo
import react.useState
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.campaigns.SelectCampaignsDialog
import ru.it_mozaika.sender.js.application.components.campaigns.SelectCampaignsDialogProps
import ru.it_mozaika.sender.js.application.context.useStore
import ru.it_mozaika.sender.js.application.moment
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.None
import web.cssom.px
import web.cssom.rem
import web.html.InputType
import kotlin.math.abs
import kotlin.math.max
import kotlin.time.Duration.Companion.days

external interface RuleGroupProps : Props {
    var properties: List<Property>
    var rule: Rule.RuleGroup
    var id: String
    var onAddRule: (isGroup: Boolean) -> Unit
    var onRemove: () -> Unit
    var onChange: (Rule.RuleGroup) -> Unit
}

val RuleGroup: FC<RuleGroupProps> = FC<RuleGroupProps> { props ->
    Grid {
        container = true
        direction = responsive(GridDirection.column)
        spacing = responsive(2)
        if (undefined == props.id) {
            sx { marginTop = 4.px }
        }
        Grid {
            item = true
            Grid {
                container = true
                spacing = responsive(2)
                direction = responsive(GridDirection.row)
                sx { alignItems = AlignItems.baseline }
                if (undefined != props.id) {
                    Grid {
                        item = true
                        Avatar {
                            sx {
                                fontSize = max(
                                    if (props.id.length > 3) {
                                        (1.25 - (props.id.length - 3) / 2 * 0.25)
                                    } else {
                                        1.25
                                    }, 0.5
                                ).rem
                            }
                            +props.id
                        }
                    }
                }
                Grid {
                    item = true
                    Typography {
                        +"Должно выполняться"
                    }
                }
                Grid {
                    item = true
                    Button {
                        variant = if (props.rule.andRuleOperator) {
                            ButtonVariant.outlined
                        } else {
                            ButtonVariant.contained
                        }
                        onClick = {
                            props.onChange(props.rule.copy(andRuleOperator = false))
                        }
                        +"Любое условие"
                    }
                }
                Grid {
                    item = true
                    Button {
                        variant = if (props.rule.andRuleOperator) {
                            ButtonVariant.contained
                        } else {
                            ButtonVariant.outlined
                        }
                        onClick = {
                            props.onChange(props.rule.copy(andRuleOperator = true))
                        }
                        +"Все условия"
                    }
                }
                Grid {
                    item = true
                    Button {
                        onClick = {
                            props.onAddRule(false)
                        }
                        +"Добавить условие"
                    }
                }
                Grid {
                    item = true
                    Button {
                        onClick = {
                            props.onAddRule(true)
                        }
                        +"Добавить составное условие"
                    }
                }
                if (undefined != props.id) {
                    Grid {
                        item = true
                        IconButton {
                            onClick = { props.onRemove() }
                            mui.icons.material.Delete()
                        }
                    }
                }
            }
            RuleGroupChildren {
                id = props.id
                rule = props.rule
                onChange = {
                    props.onChange(it)
                }
                properties = props.properties
            }
        }
    }
}

external interface RuleGroupChildrenProps : Props {
    var id: String
    var rule: Rule.RuleGroup
    var onChange: (Rule.RuleGroup) -> Unit
    var properties: List<Property>
}

private val RuleGroupChildren: FC<RuleGroupChildrenProps> = FC { props ->
    val resultProps = useMemo(props.properties) {
        listOf(Property("email", "", "Email", "email", PropertyType.String, false))
            .plus(props.properties)
    }
    val propertyTitles = useMemo(resultProps) {
        resultProps.associate { v -> v.id to v.name }
    }

    val (group, setGroup) = useState(props.rule)
    useEffect(props.rule) { setGroup(props.rule) }
    useEffect(group) {
        if (props.rule != group) {
            props.onChange(group)
        }
    }
    group.rules.forEachIndexed { index, rule ->
        val clickFunction = {
            setGroup {
                val result = it.rules.toMutableList()
                result.removeAt(index)
                group.copy(rules = result)
            }
        }
        val id = if (undefined != props.id) {
            "${props.id}.${index + 1}"
        } else {
            (index + 1).toString()
        }
        Grid {
            container = true
            direction = responsive(GridDirection.row)
            spacing = responsive(2)
            sx {
                alignItems = AlignItems.center
                if (id.contains(".")) {
                    marginLeft = 16.px
                }
                marginTop = 4.px
            }
            if (rule !is Rule.RuleGroup) {
                Grid {
                    item = true
                    Avatar {
                        sx {
                            fontSize = max(
                                if (id.length > 3) {
                                    (1.25 - (id.length - 3) / 2 * 0.25)
                                } else {
                                    1.25
                                }, 0.5
                            ).rem
                        }
                        +id
                    }
                }
            }
            Grid {
                item = true
                if (rule is Rule.RuleGroup) {
                    RuleGroup {
                        this.id = id
                        this.rule = rule
                        this.onChange = { value ->
                            setGroup {
                                val result = it.rules.toMutableList()
                                result[index] = value
                                it.copy(rules = result)
                            }
                        }
                        this.onAddRule = { isGroup ->
                            setGroup {
                                val ruleResult = rule.rules.plus(
                                    if (isGroup) {
                                        Rule.RuleGroup()
                                    } else {
                                        Rule.Segment()
                                    }
                                )
                                val result = it.rules.toMutableList()
                                result[index] = rule.copy(rules = ruleResult)
                                it.copy(rules = result)
                            }
                        }
                        this.onRemove = {
                            setGroup {
                                val result = it.rules.toMutableList()
                                result.removeAt(index)
                                it.copy(rules = result)
                            }
                        }
                        this.properties = resultProps
                    }
                } else {
                    FormControl {
                        InputLabel {
                            this.id = "rule-type-$id"
                            +"Тип отбора"
                        }
                        Select {
                            label = ReactNode("Тип отбора")
                            labelId = "rule-type-$id"
                            value = rule
                            onChange = { e, _ ->
                                setGroup {
                                    val value = e.target.value.unsafeCast<Rule>()
                                    val result = it.rules.toMutableList()
                                    result[index] = value
                                    it.copy(rules = result)
                                }
                            }
                            renderValue = {
                                ReactNode(rule.getRuleTypeTitle(propertyTitles))
                            }
                            commonRules.forEach { (groupTitle, group) ->
                                ListSubheader { +groupTitle }
                                group.forEach { (title, rule) ->
                                    MenuItem {
                                        value = rule
                                        +title
                                    }
                                }
                            }
                            ListSubheader { +"Пользовательские поля" }
                            resultProps.forEach { property ->
                                MenuItem {
                                    value = when (property.type) {
                                        PropertyType.String -> Rule.SubscriberProperty.StringDataRule(
                                            property.id,
                                            CompareType.EQUALS,
                                            ""
                                        )

                                        PropertyType.Int -> Rule.SubscriberProperty.IntDataRule(
                                            property.id,
                                            CompareType.EQUALS,
                                            0
                                        )

                                        PropertyType.Float -> Rule.SubscriberProperty.FloatDataRule(
                                            property.id,
                                            CompareType.EQUALS,
                                            0.0f
                                        )

                                        PropertyType.Date -> Rule.SubscriberProperty.DateDataRule(
                                            property.id,
                                            CompareType.EQUALS,
                                            Clock.System.now()
                                        )

                                        PropertyType.Bool -> Rule.SubscriberProperty.BooleanDataRule(
                                            property.id,
                                            CompareType.EQUALS,
                                            false
                                        )
                                    }
                                    +property.name
                                }
                            }
                        }
                    }
                }
            }

            if (rule !is Rule.RuleGroup) {
                RuleComponents {
                    this.rule = rule
                    this.onChange = { rule ->
                        setGroup {
                            val result = it.rules.toMutableList()
                            result[index] = rule
                            it.copy(rules = result)
                        }
                    }
                }
                Grid {
                    item = true
                    IconButton {
                        onClick = { clickFunction() }
                        mui.icons.material.Delete()
                    }
                }
            }
        }
    }
}

external interface RuleComponentsProps : Props {
    var rule: Rule
    var onChange: (Rule) -> Unit
}

private val RuleComponents = FC<RuleComponentsProps> { props ->
    if (props.rule is Rule.RuleGroup)
        return@FC

    val (rule, setRule) = useState(props.rule)
    useEffect(props.rule) {
        setRule(props.rule)
    }
    useEffect(rule) {
        println("Current Rule - $rule")
        if (rule != props.rule) props.onChange(rule)
    }

    when (val actualRule = if (rule is Rule.Negative) {
        rule.rule
    } else {
        rule
    }) {
        is Rule.EmailCampaign -> {
            if (actualRule.campaignIds != null) {
                Grid {
                    item = true
                    sx { display = if (actualRule.campaignIds != null) Display.block else None.none }
                    EmailCampaignSelectButton {
                        this.rule = actualRule
                        this.onChange = { ids ->
                            setRule {
                                if (it is Rule.Negative) {
                                    Rule.Negative((it.rule as Rule.EmailCampaign).copy(campaignIds = ids))
                                } else {
                                    (it as Rule.EmailCampaign).copy(campaignIds = ids)
                                }
                            }
                        }
                    }
                }
            }
            if (actualRule.compareType == CompareType.LESS_THAN_DAYS_COUNT) {
                Grid {
                    item = true
                    sx {
                        display =
                            if (actualRule.compareType == CompareType.LESS_THAN_DAYS_COUNT) Display.block else None.none
                    }
                    TextField {
                        this.value = actualRule.duration?.inWholeDays
                        this.label = ReactNode("Количество дней")
                        this.type = InputType.number
                        this.onChange = { e ->
                            val value = e.target.asDynamic().value.unsafeCast<String>().toIntOrNull() ?: 0
                            setRule {

                                if (it is Rule.Negative) {
                                    Rule.Negative((it.rule as Rule.EmailCampaign).copy(duration = value.days))
                                } else {
                                    (it as Rule.EmailCampaign).copy(duration = value.days)
                                }

                            }
                        }
                    }
                }
            } else if (actualRule.compareType != CompareType.UNKNOWN) {
                Grid {
                    item = true
                    sx { display = if (actualRule.compareType != CompareType.UNKNOWN) Display.block else None.none }
                    RuleCompareTypeSelect {
                        this.availableTypes = listOf(
                            CompareType.EQUALS,
                            CompareType.LESS,
                            CompareType.LESS_EQUALS,
                            CompareType.GREATER_EQUALS,
                            CompareType.GREATER,
                            CompareType.IN_RANGE
                        )
                        this.value = actualRule.compareType
                        this.onSelect = { compareType ->
                            setRule {
                                val value2 = if (compareType == CompareType.IN_RANGE) {
                                    actualRule.value1
                                } else {
                                    null
                                }
                                if (it is Rule.Negative) {
                                    Rule.Negative(
                                        (it.rule as Rule.EmailCampaign).copy(
                                            compareType = compareType,
                                            value2 = value2
                                        )
                                    )
                                } else {
                                    (it as Rule.EmailCampaign).copy(compareType = compareType, value2 = value2)
                                }
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    sx {
                        display =
                            if (actualRule.compareType != CompareType.UNKNOWN && actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                    }
                    RuleDateSelect {
                        this.value = actualRule.value1
                        this.onChange = { date ->
                            setRule {
                                if (it is Rule.Negative) {
                                    Rule.Negative((it.rule as Rule.EmailCampaign).copy(value1 = date))
                                } else {
                                    (it as Rule.EmailCampaign).copy(value1 = date)
                                }
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    sx {
                        display =
                            if (actualRule.compareType != CompareType.UNKNOWN && actualRule.value2 != null && actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                    }
                    RuleDateSelect {
                        this.value = actualRule.value2
                        this.onChange = { date ->
                            setRule {
                                if (it is Rule.Negative) {
                                    Rule.Negative((it as Rule.EmailCampaign).copy(value2 = date))
                                } else {
                                    (it as Rule.EmailCampaign).copy(value2 = date)
                                }
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                FormControl {
                    InputLabel {
                        id = "email-status-label"
                        +"Статус письма"
                    }
                    Select {
                        value = if (rule is Rule.Negative) actualRule.status - 100 else actualRule.status
                        label = ReactNode("Статус письма")
                        labelId = "email-status-label"
                        onChange = { e, _ ->
                            val status: Int
                            val isNegative: Boolean
                            e.target.value.unsafeCast<Int>().let {
                                isNegative = it < 0
                                status = if (isNegative) it + 100 else it
                            }

                            setRule {
                                val resultRule =
                                    ((if (it is Rule.Negative) it.rule else it) as Rule.EmailCampaign).copy(status = status)
                                if (isNegative) {
                                    Rule.Negative(rule = resultRule)
                                } else {
                                    resultRule
                                }
                            }
                        }
                        listOf(
                            EmailMessageStatus.CREATED to "Создано",
                            EmailMessageStatus.SEND to "Отправлено",
                            EmailMessageStatus.DELIVERY to "Получено",
                            EmailMessageStatus.OPEN to "Открыто",
                            EmailMessageStatus.CLICK to "Перешли по ссылке",
                        ).forEach { (value, title) ->
                            MenuItem {
                                this.value = value
                                +title
                            }
                            MenuItem {
                                this.value = value - 100
                                +"НЕ $title"
                            }
                        }
                    }
                }
            }
        }

        is Rule.Negative -> return@FC
        is Rule.RuleGroup -> return@FC
        is Rule.Segment -> {
            Grid {
                item = true
                SegmentSelect {
                    this.rule = actualRule
                    this.onChange = { id ->
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.Segment).copy(id = id))
                            } else {
                                (it as Rule.Segment).copy(id = id)
                            }
                        }
                    }
                }
            }
        }

        is Rule.SubscribeDate -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(
                        CompareType.UNKNOWN,
                        CompareType.EQUALS,
                        CompareType.LESS,
                        CompareType.LESS_EQUALS,
                        CompareType.GREATER_EQUALS,
                        CompareType.GREATER,
                        CompareType.IN_RANGE,
                    )
                    this.value = actualRule.compareType
                    this.onSelect = { compareType ->
//                        setRule {
//                            val value2 = if (compareType == CompareType.IN_RANGE) {
//                                actualRule.value1
//                            } else {
//                                null
//                            }
//                            if (compareType < 0) {
//                                Rule.Negative(
//                                    (it as Rule.SubscribeDate).copy(
//                                        compareType = compareType * -1,
//                                        value2 = value2
//                                    )
//                                )
//                            } else {
//                                (it as Rule.SubscribeDate).copy(compareType = compareType, value2 = value2)
//                            }
//                        }
                        setRule {
                            val value2 = if (compareType == CompareType.IN_RANGE) {
                                actualRule.value1
                            } else {
                                null
                            }
                            val isNegative = compareType < 0
                            val type = compareType * (if (isNegative) -1 else 1)
                            val resultRule =
                                ((if (it is Rule.Negative) it.rule else it) as Rule.SubscribeDate).copy(
                                    compareType = type,
                                    value2 = value2
                                )
                            if (isNegative) {
                                Rule.Negative(
                                    resultRule
                                )
                            } else {
                                resultRule
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                RuleDateSelect {
                    this.value = actualRule.value1
                    this.onChange = { date ->
//                        setRule {
//                            (it as Rule.SubscribeDate).copy(value1 = date)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscribeDate).copy(value1 = date))
                            } else {
                                (it as Rule.SubscribeDate).copy(value1 = date)
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.value2 != null) Display.block else None.none
                }
                RuleDateSelect {
                    this.value = actualRule.value2
                    this.onChange = { date ->
//                        setRule {
//                            (it as Rule.SubscribeDate).copy(value2 = date)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscribeDate).copy(value2 = date))
                            } else {
                                (it as Rule.SubscribeDate).copy(value2 = date)
                            }
                        }
                    }
                }
            }
        }

        is Rule.SubscriberProperty.BooleanDataRule -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(CompareType.UNKNOWN, CompareType.EQUALS)
                    this.value = actualRule.compareType
                    this.onSelect = { compareType ->
                        setRule {
                            (it as Rule.SubscriberProperty.BooleanDataRule).copy(compareType = compareType)
                        }
                    }
                }
            }
            Grid {
                item = true
                Select {
                    value = actualRule.value1
                    label = ReactNode("Значение")
                    onChange = { e, _ ->
                        val value = e.target.value.unsafeCast<Boolean>()
                        setRule {
                            (it as Rule.SubscriberProperty.BooleanDataRule).copy(value1 = value)
                        }
                    }
                    MenuItem {
                        this.value = true
                        +"Да"
                    }
                    MenuItem {
                        this.value = false
                        +"Нет"
                    }
                }
            }
        }

        is Rule.SubscriberProperty.DateDataRule -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(
                        CompareType.UNKNOWN,
                        CompareType.EQUALS,
                        CompareType.LESS,
                        CompareType.LESS_EQUALS,
                        CompareType.GREATER_EQUALS,
                        CompareType.GREATER,
                        CompareType.IN_RANGE,
                        CompareType.IS_FILLED,
                    )
                    this.value = actualRule.compareType * if (rule is Rule.Negative) -1 else 1
                    this.onSelect = { compareType ->
                        setRule {
                            val value2 = if (compareType == CompareType.IN_RANGE) {
                                actualRule.value1
                            } else {
                                null
                            }
                            val isNegative = compareType < 0
                            val type = compareType * (if (isNegative) -1 else 1)
                            val resultRule =
                                ((if (it is Rule.Negative) it.rule else it) as Rule.SubscriberProperty.DateDataRule).copy(
                                    compareType = type,
                                    value2 = value2
                                )
                            if (isNegative) {
                                Rule.Negative(
                                    resultRule
                                )
                            } else {
                                resultRule
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                }
                RuleDateSelect {
                    this.value = actualRule.value1
                    this.onChange = { date ->
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.DateDataRule).copy(value1 = date))
                            } else {
                                (it as Rule.SubscriberProperty.DateDataRule).copy(value1 = date)
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.value2 != null) Display.block else None.none
                }
                RuleDateSelect {
                    this.value = actualRule.value2
                    this.onChange = { date ->
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.DateDataRule).copy(value1 = date))
                            } else {
                                (it as Rule.SubscriberProperty.DateDataRule).copy(value2 = date)
                            }
                        }
                    }
                }
            }
        }

        is Rule.SubscriberProperty.FloatDataRule -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(
                        CompareType.UNKNOWN,
                        CompareType.EQUALS,
                        CompareType.LESS,
                        CompareType.LESS_EQUALS,
                        CompareType.GREATER_EQUALS,
                        CompareType.GREATER,
                        CompareType.IN_RANGE,
                        CompareType.IS_FILLED
                    )
                    this.value = actualRule.compareType * if (rule is Rule.Negative) -1 else 1
                    this.onSelect = { compareType ->
                        setRule {
                            val value2 = if (compareType == CompareType.IN_RANGE) {
                                actualRule.value1
                            } else {
                                null
                            }
                            val isNegative = compareType < 0
                            val type = compareType * (if (isNegative) -1 else 1)
                            val resultRule =
                                ((if (it is Rule.Negative) it.rule else it) as Rule.SubscriberProperty.FloatDataRule)
                                    .copy(
                                        compareType = type,
                                        value2 = value2
                                    )
                            if (isNegative) {
                                Rule.Negative(
                                    resultRule
                                )
                            } else {
                                resultRule
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (abs(actualRule.compareType) != CompareType.IS_FILLED) Display.block else None.none
                }
                TextField {
                    this.value = actualRule.value1
                    this.label = ReactNode("Значение 1")
                    this.type = InputType.number
                    this.onChange = { e ->
                        val value = e.target.asDynamic().value.unsafeCast<String>().toFloatOrNull() ?: 0.0f
//                        setRule {
//                            (it as Rule.SubscriberProperty.FloatDataRule).copy(value1 = value)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.FloatDataRule).copy(value1 = value))
                            } else {
                                (it as Rule.SubscriberProperty.FloatDataRule).copy(value1 = value)
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.value2 != null) Display.block else None.none
                }
                TextField {
                    this.value = actualRule.value2
                    this.label = ReactNode("Значение 2")
                    this.type = InputType.number
                    this.onChange = { e ->
                        val value = e.target.asDynamic().value.unsafeCast<String>().toFloatOrNull() ?: 0.0f
//                        setRule {
//                            (it as Rule.SubscriberProperty.FloatDataRule).copy(value2 = value)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.FloatDataRule).copy(value2 = value))
                            } else {
                                (it as Rule.SubscriberProperty.FloatDataRule).copy(value2 = value)
                            }
                        }
                    }
                }
            }
        }

        is Rule.SubscriberProperty.IntDataRule -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(
                        CompareType.UNKNOWN,
                        CompareType.EQUALS,
//                        CompareType.NOT_EQUALS,
                        CompareType.LESS,
                        CompareType.LESS_EQUALS,
                        CompareType.GREATER_EQUALS,
                        CompareType.GREATER,
                        CompareType.IN_RANGE,
                        CompareType.IS_FILLED,
//                        CompareType.NOT_EMPTY
                    )
                    this.value = actualRule.compareType * if (rule is Rule.Negative) -1 else 1
                    this.onSelect = { compareType ->
//                        setRule {
//                            val value2 = if (compareType == CompareType.IN_RANGE) {
//                                actualRule.value1
//                            } else {
//                                null
//                            }
//                            if (compareType < 0) {
//                                Rule.Negative(
//                                    (it as Rule.SubscriberProperty.IntDataRule).copy(
//                                        compareType = compareType * -1,
//                                        value2 = value2
//                                    )
//                                )
//                            } else {
//                                (it as Rule.SubscriberProperty.IntDataRule).copy(
//                                    compareType = compareType,
//                                    value2 = value2
//                                )
//                            }
//                        }
                        setRule {
                            val value2 = if (compareType == CompareType.IN_RANGE) {
                                actualRule.value1
                            } else {
                                null
                            }
                            val isNegative = compareType < 0
                            val type = compareType * (if (isNegative) -1 else 1)
                            val resultRule =
                                ((if (it is Rule.Negative) it.rule else it) as Rule.SubscriberProperty.IntDataRule)
                                    .copy(
                                        compareType = type,
                                        value2 = value2
                                    )
                            if (isNegative) {
                                Rule.Negative(
                                    resultRule
                                )
                            } else {
                                resultRule
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                }
                TextField {
                    this.value = actualRule.value1
                    this.label = ReactNode("Значение 1")
                    this.type = InputType.number
                    this.onChange = { e ->
                        val value = e.target.asDynamic().value.unsafeCast<String>().toIntOrNull() ?: 0
//                        setRule {
//                            (it as Rule.SubscriberProperty.IntDataRule).copy(value1 = value)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.IntDataRule).copy(value1 = value))
                            } else {
                                (it as Rule.SubscriberProperty.IntDataRule).copy(value1 = value)
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.value2 != null) Display.block else None.none
                }
                TextField {
                    this.value = actualRule.value2
                    this.label = ReactNode("Значение 2")
                    this.type = InputType.number
                    this.onChange = { e ->
                        val value = e.target.asDynamic().value.unsafeCast<String>().toIntOrNull() ?: 0
//                        setRule {
//                            (it as Rule.SubscriberProperty.IntDataRule).copy(value2 = value)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.IntDataRule).copy(value2 = value))
                            } else {
                                (it as Rule.SubscriberProperty.IntDataRule).copy(value2 = value)
                            }
                        }
                    }
                }
            }
        }

        is Rule.SubscriberProperty.StringDataRule -> {
            Grid {
                item = true
                RuleCompareTypeSelect {
                    this.availableTypes = listOf(
                        CompareType.UNKNOWN,
                        CompareType.EQUALS,
//                        CompareType.NOT_EQUALS,
                        CompareType.CONTAINS,
                        CompareType.STARTS_WITH,
                        CompareType.ENDS_WITH,
                        CompareType.IS_FILLED
                    )
                    this.value = actualRule.compareType * if (rule is Rule.Negative) -1 else 1
                    this.onSelect = { compareType ->
//                        setRule {
//                            if (compareType < 0) {
//                                Rule.Negative((it as Rule.SubscriberProperty.StringDataRule).copy(compareType = compareType * -1))
//                            } else {
//                                (it as Rule.SubscriberProperty.StringDataRule).copy(compareType = compareType)
//                            }
//                        }
                        setRule {
                            val isNegative = compareType < 0
                            val type = compareType * (if (isNegative) -1 else 1)
                            val resultRule =
                                ((if (it is Rule.Negative) it.rule else it) as Rule.SubscriberProperty.StringDataRule)
                                    .copy(
                                        compareType = type
                                    )
                            if (isNegative) {
                                Rule.Negative(
                                    resultRule
                                )
                            } else {
                                resultRule
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                sx {
                    display = if (actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                }
                TextField {
                    this.value = actualRule.value1
                    this.label = ReactNode("Значение")
                    this.type = InputType.text
                    this.onChange = { e ->
                        val value = e.target.asDynamic().value.unsafeCast<String>()
//                        setRule {
//                            (it as Rule.SubscriberProperty.StringDataRule).copy(value1 = value)
//                        }
                        setRule {
                            if (it is Rule.Negative) {
                                it.copy((it.rule as Rule.SubscriberProperty.StringDataRule).copy(value1 = value))
                            } else {
                                (it as Rule.SubscriberProperty.StringDataRule).copy(value1 = value)
                            }
                        }
                    }
                }
            }
        }
    }
}

external interface RuleDateSelectProps : Props {
    var value: Instant?
    var onChange: (Instant) -> Unit
}

val RuleDateSelect = FC<RuleDateSelectProps> { props ->
    var invalidDate by useState(false)
    LocalizationProvider {
        dateAdapter = AdapterMoment
        adapterLocale = "ru"
        DateTimePicker {
            asDynamic().label = ReactNode("Значение 1")
            asDynamic().value = moment(props.value?.toJSDate()) ?: moment()
            asDynamic().onChange = { newValue: dynamic ->
                if (newValue.toString() == "Invalid date" || newValue == None.none) {
                    invalidDate = true
                } else {
                    invalidDate = false
                    val localDate = LocalDateTime(
                        newValue.year() as Int,
                        (newValue.month() as Int) + 1,
                        newValue.date() as Int,
                        newValue.hour() as Int,
                        newValue.minute() as Int,
                        newValue.second() as Int
                    )
                    props.onChange(localDate.toInstant(TimeZone.currentSystemDefault()))
                }
            }
            asDynamic().renderInput = { p: Props ->
                TextField.create {
                    sx {
                        display = if (props.value != null) Display.block else None.none
                    }
                    fullWidth = true
                    +p
                }
            }
        }
    }
}

external interface SegmentSelectProps : Props {
    var rule: Rule.Segment
    var onChange: (String) -> Unit
}

private val SegmentSelect = FC<SegmentSelectProps> { props ->
    var segments by useState(emptyMap<String, String>())
    useEffect(props.rule.staticSegment) {
        Http.get(
            if (props.rule.staticSegment) {
                "/segments/static"
            } else {
                "/segments"
            }
        ) { response ->
            response.checkResponseError()?.let {
                return@get
            }
            segments = response.body<List<NamedItem>>().associate { it.id to it.name }
        }
    }
    FormControl {
        InputLabel {
            this.id = "rule-segment-select"
            +"Сегмент"
        }
        Select {
            sx {
                minWidth = 200.px
            }
            label = ReactNode("Сегмент")
            labelId = "rule-segment-select"
            value = props.rule.id
            onChange = { e, _ ->
                val value = e.target.value
                props.onChange(value)
            }
            segments.forEach {
                MenuItem {
                    value = it.key
                    +it.value
                }
            }
        }
    }
}

external interface EmailCampaignSelectButtonProps : SelectCampaignsDialogProps {
    var rule: Rule.EmailCampaign
    var onChange: (List<String>) -> Unit
}

private val EmailCampaignSelectButton = FC<EmailCampaignSelectButtonProps> { props ->
    var selectDialogOpened by useState(false)
    Button {
        variant = ButtonVariant.contained
        onClick = {
            selectDialogOpened = true
        }
        +if (props.rule.campaignIds.isNullOrEmpty()) "Выбрать рассылки" else "Выбрано рассылок: ${props.rule.campaignIds?.size ?: 0}"
    }

    SelectCampaignsDialog {
        open = selectDialogOpened
        onClose = { ids ->
            selectDialogOpened = false
            props.onChange(ids)
        }
        selectedCampaigns = props.rule.campaignIds ?: emptyList()
    }
}

private fun Rule.getRuleTypeTitle(properties: Map<String, String>): String {
    return when (this) {
        is Rule.EmailCampaign -> when {
            campaignIds != null -> "Активность в рассылках"
            compareType == CompareType.UNKNOWN -> "Активность в любых рассылках"
            compareType == CompareType.LESS_THAN_DAYS_COUNT -> "Активность в недавних рассылках"
            else -> "Активность в указанный период"
        }

        is Rule.Negative -> {
            val result = rule.getRuleTypeTitle(properties)
            if (this.rule is Rule.EmailCampaign || this.rule is Rule.SubscriberProperty) {
                result
            } else {
                "Не ${result.lowercase()}"
            }
        }

        is Rule.Segment -> if (staticSegment) {
            "Входит в статический сегмент"
        } else {
            "Входит в сегмент"
        }

        is Rule.SubscribeDate -> "Дата подписки"
        is Rule.SubscriberProperty -> properties[fieldId].orEmpty()
        is Rule.RuleGroup -> "Составное условие"
    }
}

private val commonRules = listOf(
    "Сегменты" to listOf(
        "Входит в сегмент" to Rule.Segment(false, ""),
        "Не входит в сегмент" to Rule.Negative(Rule.Segment(false, "")),
        "Входит в статический сегмент" to Rule.Segment(true, ""),
        "Не входит в статический сегмент" to Rule.Negative(Rule.Segment(true, "")),
    ),
    "Активность в рассылках" to listOf(
        "В выбранных рассылках" to Rule.EmailCampaign(campaignIds = emptyList()),
        "В любых рассылках" to Rule.EmailCampaign(),
        "В недавних рассылках" to Rule.EmailCampaign(compareType = CompareType.LESS_THAN_DAYS_COUNT),
        "В указанный период" to Rule.EmailCampaign(compareType = CompareType.EQUALS),
    ),
    "Подписки" to listOf(
        "Дата подписки" to Rule.SubscribeDate(listOf(), CompareType.EQUALS, Clock.System.now()),
    ),
)